import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { page as InsightPage } from '@/__generated__/requests'
import { InsightsService } from '@/__generated__/requests'

export const INSIGHTS_QUERY_KEY = 'insights'

export function useInsightsQuery(page: InsightPage) {
  return useQuery({
    gcTime: 30 * 60 * 1000,
    placeholderData: keepPreviousData,
    queryFn: () => InsightsService.insightsControllerGetInsights({ page }),
    queryKey: [INSIGHTS_QUERY_KEY, page],
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  })
}
